import React from "react";
import Headline from "./Headline";
import { notification, Tabs, TabsProps } from "antd";
import PostsApi from "../../api-services/posts-api.service";
import { Link, useSearchParams } from "react-router-dom";
import HomeLink from "../../widgets/HomeLink";
import { Post } from "../../interfaces/post.interface";

const bannerPath = '/iceholidays-assets/images/news&blogs_cover.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'News & Blogs' }
]
const types = [
  {value: 'news_and_events', label: 'News'},
  // {value: 'blog', label: 'Blogs'},
] 


function withSearchParams(Component) {
  return props => <Component {...props} searchParams={useSearchParams()} />;
}

class NewsAndBlogsPage extends React.Component<{searchParams}> {
  postsApi = new PostsApi;

  state = {
    posts: [],
    activeTab: "news_and_events"
  }
  
  componentDidMount() {
    const [searchParams] = this.props.searchParams;
    const type = searchParams.get('type') || this.state.activeTab;
    this.getPosts(type);
  }


  getPosts(type){
    this.postsApi.getPosts(type)
      .then(({posts}) => {
        this.setState({posts})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading posts.'});
      });
  }

  

  changeTab (tab) {
    this.setState({activeTab:tab});
    this.getPosts(tab);
  }


  render(){
    var items:TabsProps["items"] = types.map(type => {
      return {
        key: type.value,
        label: type.label,
        children: (
          <div className="blogs">
            {
              this.state.posts?.map((blog:Post) => (
                <Link to={`${blog.id}?type=${blog.type}`} className="blog">
                  <img src={blog.thumbnail}/>
                  <div className="details">
                    <span className="date">{blog.publishedDate}</span>
                    <span className="title">{blog.title}</span>
                  </div>
                </Link>
              ))
            }
          </div>
        )
      }
    })

    return (
      <div id="news-blogs" className="gd-series-tour-page">
        <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
          <span className="title">
            News & Blogs
          </span>
        </Headline>

        <div className="gd-series-tour-page_body">
          <Tabs 
            defaultActiveKey="1" 
            activeKey={this.state.activeTab}
            items={items}
            type="card"
            onChange={(selected)=>this.changeTab(selected)}/>
        </div>

      </div>
    )
  }
}

export default withSearchParams(NewsAndBlogsPage);